/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import axios from 'axios'
import ReactHtmlParser from 'react-html-parser'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import NotesIcon from '@mui/icons-material/Notes'
import FormatQuoteIcon from '@mui/icons-material/FormatQuote'

import { viewFeedbackAndVerdictForItemJSX } from '../../../analysisJSX/viewFeedbackAndVerdictForItemJSX'

import { positionChangeWidthSm, navbarHeight, footerHeight, tinderProfileBackgroundColor, tinderProfileItemBackgroundColor, tinderProfileItemBorderColor, tinderProfileTextColor, tinderProfilePromptTextColor, tinderProfileItemDividerOpacity, tinderProfileItemBoxShadow, tinderProfileItemBorderWidth, tinderProfileItemBorderRadius, tinderProfileImageWidth, tinderProfileImageIndicatorWidth, tinderLeadImageHeight, tinderImageHeight, swipelyticsTurquoise, profPicDefaultURL } from '../../../../../helpers/variableDefaults'

export const viewTinderPromptItem = (viewFeedbackTrue, giveFeedbackTrue, promptIndex, datingProfile, width) => {
  // console.log('prompt index ->', promptIndex)
  // console.log('datingProfile ->', datingProfile)
  return (
    <Box
      sx={{
        mt: 2,
        width: tinderProfileImageWidth(width),
        backgroundColor: tinderProfileItemBackgroundColor,
        boxShadow: tinderProfileItemBoxShadow, 
        borderRadius: (giveFeedbackTrue || viewFeedbackTrue) ? `${tinderProfileItemBorderRadius} ${tinderProfileItemBorderRadius} 0px 0px` : tinderProfileItemBorderRadius,
      }}
    >
      {/* Prompt */}
      <Box
        sx={{
          pt: 2, px: 2,
          fontWeight: 'bold',
          color: tinderProfilePromptTextColor,
          display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
        }}
      >

        < FormatQuoteIcon
          sx={{
            // width: '30px', height: '30px',
            mr: 1,
            // '-webkit-transform': 'rotate(-180deg)',
            transform: 'rotate(-180deg)',
          }}
        />
        <Typography
          sx={{
            fontWeight: 'bold',
            fontSize: '14px',
            // color: tinderProfilePromptTextColor,
          }}
        >
          {datingProfile.bio.prompts[promptIndex].prompt}
        </Typography>
      </Box>

      {/* Response */}
      <Box
        sx={{
          pt: 1, pb: 2, px: 2,
          color: tinderProfileTextColor,
          fontSize: '20px',
          fontWeight: 'bold',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
        }}
      >
        {datingProfile.bio.prompts[promptIndex].response}
      </Box>

      {viewFeedbackTrue && datingProfile.bioFeedback.promptsFeedback[promptIndex].feedback.length > 0 && datingProfile.bioFeedback.promptsFeedback[promptIndex].verdict.length > 0 &&
        <Box
          sx={{
            width: tinderProfileImageWidth(width),
            borderRadius: `0px 0px ${tinderProfileItemBorderRadius} ${tinderProfileItemBorderRadius}`,
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
          }}
        >
          {/* Divider */}
          <Divider sx={{ width: '100%', my: 0 }} orientation="horizontal" />

          {/* Feedback and Verdict */}
          {viewFeedbackAndVerdictForItemJSX(datingProfile.bioFeedback.promptsFeedback[promptIndex], 'prompts', datingProfile.type)}

        </Box>
      }

    </Box>
  )
}